import React from "react";
import DateHelpers from '../Helper/DateHelpers.js';
import AddTransaction from '../Routes/AddTransaction.js'
import AccountDetails from "./AccountDetails.js";
import ViewTransactionHistory from './ViewTransactionHistory.js'
import { useNavigate } from "react-router-dom";
import RegistrationInfo from "./RegistrationInfo.js";
import { useState, useEffect } from "react";
import '../Styles/AdminReservationCard.scss';
import GroupAccountDetails from "./GroupAccountDetails.js";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import RegistrationDetails from "./RegistrationDetails.js"

function AdminReservationCard({ queriedReservation }) {

   const [groupAccountDetailsVisibility, setGroupAccountDetailsVisibility] = useState(false)
   console.log("reservation", queriedReservation)
   return(
      <div className="AdminReservationCardContainer">
         <div className="AdminReservationCardContent">
            <div className="AdminReservationCardEventInfo">
               <div className="AdminReservationCardName">
                  {queriedReservation.group_name + " (" + queriedReservation.group_city + ", " + queriedReservation.group_state + ")"}
               </div>
               <div className="AdminReservationCardEventName">
                  {queriedReservation.camp_name}
               </div>
               <div className="AdminReservationCardDates">
                  Dates: {DateHelpers.getEventDateRange(queriedReservation.begin_date, queriedReservation.end_date)}
               </div>
                <div className="AdminReservationCardNumberOfSpots">
                  Estimated Camper Count: {queriedReservation.num_spots_reserved}
               </div>
               <div className="AdminReservationCardFastTrackInfo">
                  Reservation Type: {queriedReservation.is_fast_track === true ? "Fast Track" : "Standard"}
               </div>
               <div className="AdminReservationCardDeluxeRoomInfo">
                  {queriedReservation.is_fast_track === true && queriedReservation.free_room_option === true ? "Deluxe":""}
               </div>
               <div className="AdminReservationCardAccountDetailsButton">
                  <button onClick={() => setGroupAccountDetailsVisibility(!groupAccountDetailsVisibility)}>
                     Account Details
                  </button>
               </div>
            </div>
            { groupAccountDetailsVisibility === true && 
               <GroupAccountDetails
               reservationInfo = {queriedReservation}
               setViewGroupAccountDetailsVisibility={setGroupAccountDetailsVisibility}/>
            }
         </div>
      </div>
   )
}
export default AdminReservationCard